import VueRouter from 'vue-router'
import Vue from 'vue';

Vue.use(VueRouter);

const routes = [
  /*{
    path: '/a/:apiKey',
    name: 'auth',
    props: true,
    component: () => import('@/views/Auth/AuthView.vue')
  },
  {
    path: '/oldchat',
    name: 'chat1',
    component: () => import('@/views/Chat/ChatView.vue')
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/views/EmbedChat/EmbedChatView.vue')
  },*/
  {
    path: '/',
    name: 'view',
    component: () => import('@/views/Wizard/WizardView.vue')
  },/*
  {
    path: '/na',
    name: 'notAuthenticated',
    component: () => import('@/views/NotAuthenticated/NotAuthenticatedView.vue')
  }*/
];

const router = new VueRouter({
  routes // short for `routes: routes`
})

router.beforeEach(async (to, from, next) => {


  next();
  //const userState = useLocalStorage('hubble-chat-user', {email: null}, {mergeDefaults: true});
  /*const isAuthenticated = userState.value.email !== null;
  const anonymousRoutes = ['auth', 'notAuthenticated'];
  if (!isAuthenticated && !anonymousRoutes.includes(to.name)) {
    next({name: 'notAuthenticated'});
  } else {
    next();
  }*/
})


export default router;
